/**
 * Class description
 *
 * Created: 2019-08-01
 * @author jonas
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinterHoardLayerConfig} from "../config/WinterHoardLayerConfig";
import {TimelineLite, Timeline} from "gsap";
import {WinterHoardParsedGameData} from "../server/data/IWinterHoardServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {WinterHoardGameModuleConfig} from "../WinterHoardGameModuleConfig";



export class WinterHoardFreespinCounterView extends BaseView {
    private _meterWrapper:PIXI.Sprite;
    private _meters:PIXI.Sprite [] = [];
    private _indicatorSprites:PIXI.Sprite [] = [];

    constructor() {
        super();
    }

    protected initAnimations():void {
        //this.position.set(0, 11)

        this._meterWrapper = this.createSymMeter();

        StageManager.getLayer(WinterHoardLayerConfig.FREESPIN_COUNTERS.name).addChild(this);
        this.addChild(this._meterWrapper);
        this.visible = false;
    }

    protected createSymMeter():PIXI.Sprite {
        const wrapper:PIXI.Sprite = new PIXI.Sprite();

        [5,4,3,2].forEach((symValue:number) => {
            const symSprite:PIXI.Sprite = new PIXI.Sprite(); //new PIXI.Sprite(GameResources.getTextures("indicatorM" + symValue)[0]);
            symSprite.name = "M" + symValue;

            const xOffset:number = 20;
            const yOffset:number = -45;
            [1, 2, 3, 4, 5].forEach((indicator:number, index:number) => {
                const sprite:PIXI.Sprite = new PIXI.Sprite();  //new PIXI.Sprite(GameResources.getTextures("tmpEnergy")[0]);
                //sprite.tint = 0xCCCCCC;
                sprite.name = "indicator" + indicator;
                sprite.width = 60;
                sprite.height = 60;
                sprite.alpha = 0.6;
                sprite.visible = false;

                switch(index) {
                    case 0:
                        sprite.y = 120;
                        sprite.x = 15;
                        break;
                    case 1:
                        sprite.y = 120;
                        sprite.x = 100;
                        break;
                    case 2:
                        sprite.y = 40;
                        sprite.x = -10;
                        break;
                    case 3:
                        sprite.y = 40;
                        sprite.x = 130;
                        break;
                    case 4:
                        sprite.y = -15;
                        sprite.x = 60;
                        break;
                }

                /*if(indicator >= 4) {
                    sprite.y = yOffset + symSprite.y + (symSprite.height * 1.15);
                    sprite.x = xOffset + symSprite.x + (indicator - 3) * (symSprite.width / 4.5);
                }
                else {
                    sprite.y = yOffset + symSprite.y + symSprite.height;
                    sprite.x = xOffset + symSprite.x + index * (symSprite.width / 3);
                }*/

                symSprite.addChild(sprite);
                this._indicatorSprites.push(sprite);
            });

            const m1Sprite:PIXI.Sprite = new PIXI.Sprite(); //new PIXI.Sprite(GameResources.getTextures("indicatorM1")[0]);
            m1Sprite.name = "M1";
            m1Sprite.visible = false;


            this._meters.push(symSprite);
            wrapper.addChild(symSprite);
            symSprite.addChild(m1Sprite);
        });

        return wrapper;
    }

    protected onResize(resizeData: IResizeData): void {
        if(resizeData.orientation === Orientation.LANDSCAPE) {
            this._meterWrapper.scale.set(0.65, 0.65);
            this._meterWrapper.x = -280;
            this._meterWrapper.y = 380;

            const yOffset:number = 10;
            this._meters.forEach((symSprite:PIXI.Sprite, index:number) => {
                symSprite.y = index * -symSprite.height + yOffset;
                symSprite.x = 0;
            })
        }
        else {
            this._meterWrapper.scale.set(0.7, 0.7);
            this._meterWrapper.x = 120;
            this._meterWrapper.y = -40;

            const xOffset:number = -15;
            this._meters.forEach((symSprite:PIXI.Sprite, index:number) => {
                symSprite.x = index * symSprite.width + xOffset;
                symSprite.y = 0;
            })
        }
    }

    public updateData(collectedBefore:number, collectedAfter:number, collectPositions:boolean [][], isRestore:boolean = false, totalFsLeft:number):Timeline [] {
        const tlArr:Timeline [] = [];

        const energyCollectedBefore:number = collectedBefore;
        const energyCollectedAfter:number = collectedAfter;
        const energyCollectPositions:boolean [][] = collectPositions;
        const fsLeft:number = totalFsLeft;

        const updateCount:number = collectedAfter - collectedBefore;
        let nrOfCollectPositions:number = 0;

        // TODO: Do check in symbol/symbol data to prevent addition of energy
        //if(collectedBefore >= 20) {
            //return [new TimelineLite()];
        //}

        energyCollectPositions.forEach((arr) => {
            arr.forEach((bool) => {
                if(bool) {
                    nrOfCollectPositions++;
                }
            });
        });

        //console.log("UPDATE COUNT: " + updateCount);
        //console.log("NUMBER OF COLLECT POSITIONS: " + nrOfCollectPositions);

        // TODO: The purpose here is to validate model data with view update,
        //  and only return a list with paused timelines that will be injected to the presentation timeline.



        // Validation and update
        let cntr:number = 0;
        if(energyCollectedBefore < energyCollectedAfter) {
            for(let i = energyCollectedBefore; i < energyCollectedAfter; i++) {
                const tl:Timeline = new TimelineLite({paused:true});
                /*
                [4, 3, 2, 1].forEach((level) => {
                    [1, 2, 3, 4, 5].forEach((energy) => {
                        //testTL.add(() => {
                            //this.fillMeterEnergy(level, energy);
                        //}, "+=0.4")
                    });
                });
                 */
                if(!isRestore && cntr === 0) {
                    tl.add(() => {}, "+=1");
                }

                tl.add(() => {
                    //if(this._indicatorSprites[i]) {
                        if(i > -1 && i < 5) {
                            switch(i) {
                                case 0: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(4, 1); break;
                                case 1: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(4, 2); break;
                                case 2: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(4, 3); break;
                                case 3: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(4, 4); break;
                                case 4: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(4, 5); break;
                            }
                        }
                        else if(i > 4 && i < 10) {
                            switch(i) {
                                case 5: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(3, 1); break;
                                case 6: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(3, 2); break;
                                case 7: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(3, 3); break;
                                case 8: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(3, 4); break;
                                case 9: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(3, 5); break;
                            }
                        }
                        else if(i > 9 && i < 15) {
                            switch(i) {
                                case 10: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(2, 1); break;
                                case 11: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(2, 2); break;
                                case 12: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(2, 3); break;
                                case 13: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(2, 4); break;
                                case 14: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(2, 5); break;
                            }
                        }
                        else if(i > 14 && i < 20) {
                            switch(i) {
                                case 15: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(1, 1); break;
                                case 16: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(1, 2); break;
                                case 17: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(1, 3); break;
                                case 18: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(1, 4); break;
                                case 19: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(1, 5); break;
                            }
                        }
                        //this._indicatorSprites[i].visible = true;
                    //}
                    switch(i) {
                        case 4:

                            WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(4, undefined, undefined, fsLeft, isRestore);
                            //this._meters[0].getChildByName("M1").visible = true;
                            break;
                        case 9:
                            WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(3, undefined, undefined, fsLeft, isRestore);
                            //this._meters[1].getChildByName("M1").visible = true;
                            break;
                        case 14:

                            WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(2, undefined, undefined, fsLeft, isRestore);
                            //this._meters[2].getChildByName("M1").visible = true;
                            break;
                        case 19:
                            WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(1, undefined, undefined, fsLeft, isRestore);
                            WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(0, undefined, undefined, fsLeft, isRestore);
                            //WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(0);
                            //this._meters[3].getChildByName("M1").visible = true;
                            break;
                    }
                }, (isRestore)? 0 : "+=0.4");


                tlArr.push(tl);
            }
            cntr++;
        }
        else if(energyCollectedAfter >= 20 && isRestore) {
            WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(4, undefined, undefined, fsLeft, isRestore);
            WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(3, undefined, undefined, fsLeft, isRestore);
            WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(2, undefined, undefined, fsLeft, isRestore);
            WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(1, undefined, undefined, fsLeft, isRestore);
            WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(0, undefined, undefined, fsLeft, isRestore);
        }

        if(!isRestore) {
            tlArr.push(new TimelineLite().add(() => {}, "+=1"));
        }


        return tlArr;
    }

    public update(reelId:number, sound:boolean = false):TimelineLite {
        const data:WinterHoardParsedGameData = <WinterHoardParsedGameData>SlotGame.model.gameData;

        const tl:TimelineLite = new TimelineLite(); //this._counters[reelId].update(data.scattersCollected[reelId]);

        if (sound && tl.duration() > 0){
            //tl.add(()=>SoundPlayer.playEffect(WinterHoardSoundConfig.SCATTER_COUNTER_UP));
        }

        return tl;
    }

    public updateAll():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        //for(let i:number = 0; i < this._counters.length; i++) {
            //tl.add(this.update(i), 0);
        //}
        return tl;
    }

    public show() {
        //this.visible = true;
        //StageManager.getLayer(WinterHoardLayerConfig.FREESPIN_COUNTERS.name).addChild(this);
        WinterHoardGameModuleConfig.indicatorBackground.activateEnteringFS();
    }

    public hide() {
        this.visible = false;
        this._meters.forEach((sprite) => {
            sprite.getChildByName("M1").visible = false;
        });

        this._indicatorSprites.forEach((indicator) => {
            indicator.visible = false;
        });

        WinterHoardGameModuleConfig.indicatorBackground.deactivateExitingFS();
        //StageManager.getLayer(WinterHoardLayerConfig.FREESPIN_COUNTERS.name).removeChild(this);
    }
}